import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static values = { url: String }

  selectProduct(event) {
    const product = event.currentTarget.value
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("product", product)

    get(url.toString(), { responseKind: "turbo-stream" })
  }
}
